import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

/**
 * @author SudTechnologies
 */
@Injectable()
export class Env {
    public tokenAuthString: 'Basic YW5kcm9pZF9jbGllbnQ6MTIzNDU2';
    public ANGULAR_CLIENT_ID: string;
    public ANGULAR_CLIENT_SECRET: string;
    private URL_BASE: string;
    private TOKEN: string;
    private REST_VERSION: string;
    private ENDPOINTS;
    public FOLDER_IMAGES;
    private URL_IMAGE: string;
    public URL_IMAGE_BASE: string;
    public URL_IMAGE_SUFFIX: string;

    public oauth: string;
    public access: string;
    public roles: string;
    public user: string;
    public param: string;
    public publicParam: string;
    public menu: string;
    public bank: string;
    public publicMenu: string;
    public slider: string;
    public contract: string;
    public evaluation: string;
    public property: string;
    public division: string;
    public payment: string;
    public tenant: string;

    public slider_image: string;

    public number_characters: number;

    constructor() {
        this.URL_BASE =  environment.URL_BASE;
        this.URL_IMAGE = environment.URL_IMAGE;
        this.URL_IMAGE_BASE = environment.URL_IMAGE_BASE;
        this.URL_IMAGE_SUFFIX = environment.URL_IMAGE_SUFFIX;
        this.TOKEN = '';
        this.ANGULAR_CLIENT_ID = environment.ANGULAR_CLIENT_ID;
        this.ANGULAR_CLIENT_SECRET = environment.ANGULAR_CLIENT_SECRET;
        this.REST_VERSION = environment.REST_VERSION;
        enum endpoint {
                        OAuth = '/oauth/token',
                        Access = '/secured/access',
                        Roles = '/secured/role',
                        User = '/secured/user',
                        Param = '/secured/param',
                        PublicParam = '/public/param',
                        Bank = '/secured/bank',
                        Menu = '/secured/menu',
                        PublicMenu = '/public/menu',
                        Slider = '/secured/slider',

                        Contract = '/secured/contract',
                        Evaluation = '/secured/evaluation',
                        Property = '/secured/property',
                        Division = '/secured/division',
                        Payment = '/secured/payment',
                        Tenant = '/secured/tenant'
                    }
        this.ENDPOINTS = endpoint;

        this.oauth = this.URL_BASE + this.ENDPOINTS.OAuth;
        this.access = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Access;
        this.roles = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Roles;
        this.user = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.User;
        this.param = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Param;
        this.publicParam = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.PublicParam;
        this.menu = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Menu;
        this.bank = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Bank;
        this.publicMenu = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.PublicMenu;
        this.slider = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Slider;
        this.contract = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Contract;
        this.evaluation = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Evaluation;
        this.property = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Property;
        this.division = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Division;
        this.payment = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Payment;
        this.tenant = this.URL_BASE + this.REST_VERSION + this.ENDPOINTS.Tenant;


        enum folder_image {
          Slider = 'sliders',
          Bank = 'bank'
        }
        this.FOLDER_IMAGES = folder_image;
        this.slider_image = this.URL_IMAGE + this.FOLDER_IMAGES.Slider;

        this.number_characters = 3;
    }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/env.ts